<template>
    <div style="margin: 0 auto" :style="$vuetify.breakpoint.mobile ? 'width: 100%; padding: 0 30px;' : 'width: 1024px'">
        <v-list>
            <v-list-group
                v-for="item in datas"
                :key="item.id"
                no-action
            >
            
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item style="padding-left: 20px">
                    <v-list-item-content>
                        <v-row>
                            <v-col class="py-1 px-0" v-for="data in item.sub_info" :key="data.id" :cols="!(data.type_ui) || data.type_ui == 'text'? 6 : 12">
                                <div style="display: flex;" v-if="(!(data.type_ui) || data.type_ui === 'text') && data.show">
                                    <span style="min-width: 170px;">{{ data.name }}</span>:

                                    <span v-if="! data.type_ui"> {{ data.value }}</span>
                                    <span v-else>
                                        <span v-for="(nest, nest_index) in data.value" :key="nest.id">
                                            {{ nest_index == 0 ? '' : (nest.name || nest.value ? ', ' : '')}} {{ nest.name ? nest.name : nest.value }}
                                        </span>
                                    </span>    
                                </div>

                                <fieldset v-if="data.type_ui && data.type_ui === 'card'" style="min-height: 100px; margin: 10px 0; padding: 0 10px; border-radius: 5px; border-width: 0; border: 2px solid #e4e4e4;">
                                    <legend style="padding: 0 6px">{{ data.name }}</legend>
                                        <v-row>
                                            <v-col class="py-1 px-0" v-for="card in data.value" :key="card.id" cols="6">
                                                <div style="display: flex;">
                                                    <span style="min-width: 170px;">{{ card.name }}</span>:

                                                    <span v-if="! card.type_ui">{{ card.value }}</span>
                                                    <span v-else>
                                                        <span v-for="(nest, nest_index) in card.value" :key="nest.id">
                                                            {{ nest_index == 0 ? '' : (nest_index == 0 ? ', ' : '')}} {{ nest.name ? nest.name : nest.value }}
                                                        </span>
                                                    </span>    
                                                </div>
                                            </v-col>
                                        </v-row>
                                </fieldset>

                                 <fieldset v-if="data.type_ui && data.type_ui === 'list'" style="margin: 10px 0; padding: 0 10px; border-radius: 5px; border-width: 0; border: 2px solid #e4e4e4;">
                                    <legend style="padding: 0 6px">{{ data.name }}</legend>
                                        <table v-for="(header, header_index) in data.value.header" :key="header_index" style="margin-top: 10px; width: 100%; text-align: left; border-collapse: collapse">
                                            <tr>
                                                <td style="padding: 7px 5px; background: #84B628; color: #ffffff" v-for="(th, th_key) in header" :key="th_key">{{ th }}</td>
                                            </tr>

                                            <tr v-for="(td, td_key) in (data.value.header.length > 1 ? data.value.value[header_index] : data.value.value) " :key="td_key">
                                                <td v-for="(t, t_key) in td" :key="t_key" style="padding: 7px 5px;">{{ t }}</td>
                                            </tr>

                                        </table>
                                </fieldset>

                            </v-col>
                        </v-row>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>
        </v-list>
    </div>
</template>

<script>

    import OptionDataMixin from "../../../../mixins/optionDataMixin";
    import MainMixin from "../../../../mixins/mainMixin";
    import ValidatorMixin from "../../../../mixins/validatorMixin";

    export default {
        name: "membershipCareerInformation",
        mixins: [OptionDataMixin, MainMixin, ValidatorMixin],
        data() {
            return {};
        },
        computed: {
            datas(){
                return this.$store.state.membership.tab_items
            }
        },  
        methods: {},
        watch: {}
    };
</script>
